"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _content = require("./content.constant");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // @flow
var INIT_STATE = {
  create: null,
  loading: false,
  createRootNode: null,
  editorLock: null,
  editorUnlock: null,
  editor: null,
  softDelete: null,
  listSoftDelete: null,
  restoreDelete: null,
  softBulkDelete: null,
  hardBulkDelete: null,
  restoreBulkDelete: null
};
var content = function content() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _content.actionTypes.CREATE:
    case _content.actionTypes.UPDATE:
    case _content.actionTypes.DELETE:
    case _content.actionTypes.ADD_ACCESS_PERMISSION:
    case _content.actionTypes.UPDATE_ACCESS_PERMISSION:
    case _content.actionTypes.LIST_ACCESS_PERMISSION:
    case _content.actionTypes.CHECK_VALID_CP_NAME:
    case _content.actionTypes.LIST_CP_SLIDES:
    case _content.actionTypes.DUPLICATE:
    case _content.actionTypes.UPDATE_PUBLISH:
    case _content.actionTypes.CREATE_ROOT_NODE:
    case _content.actionTypes.EDITOR_LOCK:
    case _content.actionTypes.EDITOR_UNLOCK:
    case _content.actionTypes.EDITOR:
    case _content.actionTypes.SOFT_DELETE:
    case _content.actionTypes.SOFT_RESTORE:
    case _content.actionTypes.BULK_SOFT_DELETE:
    case _content.actionTypes.BULK_SOFT_RESTORE:
    case _content.actionTypes.BULK_HARD_DELTETE:
    case _content.actionTypes.LIST_SOFT_DELETE:
      return {
        loading: true
      };
    case _content.actionTypes.SUCCESS:
      switch (action.payload.actionType) {
        case _content.actionTypes.CREATE_ROOT_NODE:
          return _objectSpread(_objectSpread({}, state), {}, {
            createRootNode: action.payload.data,
            loading: false
          });
        case _content.actionTypes.SOFT_DELETE:
          {
            return _objectSpread(_objectSpread({}, state), {}, {
              softDelete: action.payload.data,
              loading: false
            });
          }
        case _content.actionTypes.SOFT_RESTORE:
          {
            return _objectSpread(_objectSpread({}, state), {}, {
              restoreDelete: action.payload.data,
              loading: false
            });
          }
        case _content.actionTypes.BULK_SOFT_DELETE:
          {
            return _objectSpread(_objectSpread({}, state), {}, {
              softBulkDelete: action.payload.data,
              loading: false
            });
          }
        case _content.actionTypes.BULK_SOFT_RESTORE:
          {
            return _objectSpread(_objectSpread({}, state), {}, {
              restoreBulkDelete: action.payload.data,
              loading: false
            });
          }
        case _content.actionTypes.BULK_HARD_DELTETE:
          {
            return _objectSpread(_objectSpread({}, state), {}, {
              hardBulkDelete: action.payload.data,
              loading: false
            });
          }
        case _content.actionTypes.LIST_SOFT_DELETE:
          {
            return _objectSpread(_objectSpread({}, state), {}, {
              listSoftDelete: action.payload.data,
              loading: false
            });
          }
        case _content.actionTypes.CREATE:
          {
            return _objectSpread(_objectSpread({}, state), {}, {
              create: action.payload.data,
              loading: false
            });
          }
        case _content.actionTypes.UPDATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            update: action.payload.data
          });
        case _content.actionTypes.UPDATE_PUBLISH:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            updatePublish: action.payload.data
          });
        case _content.actionTypes.EDITOR_LOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorLock: action.payload.data
          });
        case _content.actionTypes.EDITOR_UNLOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorUnlock: action.payload.data
          });
        case _content.actionTypes.EDITOR:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editor: action.payload.data
          });
        case _content.actionTypes.DELETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            delete: action.payload.data
          });
        case _content.actionTypes.ADD_ACCESS_PERMISSION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            addPermission: action.payload.data
          });
        case _content.actionTypes.UPDATE_ACCESS_PERMISSION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            updatePermission: action.payload.data
          });
        case _content.actionTypes.LIST_ACCESS_PERMISSION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            permissionList: action.payload.data
          });
        case _content.actionTypes.CHECK_VALID_CP_NAME:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            checkCPName: action.payload.data
          });
        case _content.actionTypes.LIST_CP_SLIDES:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            slides: action.payload.data
          });
        case _content.actionTypes.DUPLICATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            duplicate: action.payload.data
          });
        case _content.actionTypes.SEND_NOTIFICATION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            sendNotification: true
          });
        case _content.actionTypes.SAVE_AS_DRAFT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            saveAsDraft: action.payload.data
          });
        default:
          return _objectSpread({}, state);
      }
    case _content.actionTypes.ERROR:
      switch (action.payload.actionType) {
        case _content.actionTypes.CREATE_ROOT_NODE:
        case _content.actionTypes.UPDATE_PUBLISH:
        case _content.actionTypes.DELETE:
        case _content.actionTypes.ADD_ACCESS_PERMISSION:
        case _content.actionTypes.UPDATE_ACCESS_PERMISSION:
        case _content.actionTypes.LIST_ACCESS_PERMISSION:
        case _content.actionTypes.CHECK_VALID_CP_NAME:
        case _content.actionTypes.LIST_CP_SLIDES:
        case _content.actionTypes.DUPLICATE:
        case _content.actionTypes.SAVE_AS_DRAFT:
        case _content.actionTypes.SOFT_DELETE:
        case _content.actionTypes.SOFT_RESTORE:
        case _content.actionTypes.BULK_SOFT_DELETE:
        case _content.actionTypes.BULK_SOFT_RESTORE:
        case _content.actionTypes.LIST_SOFT_DELETE:
        case _content.actionTypes.CREATE:
          {
            return _objectSpread(_objectSpread({}, state), {}, {
              error: action.payload.error,
              loading: false
            });
          }
        case _content.actionTypes.BULK_HARD_DELTETE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            hardBulkDelete: action.payload.error
          });
        case _content.actionTypes.EDITOR_LOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorLock: action.payload.error
          });
        case _content.actionTypes.EDITOR_UNLOCK:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editorUnlock: action.payload.error
          });
        case _content.actionTypes.EDITOR:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            editor: action.payload.error
          });
        case _content.actionTypes.UPDATE:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            error: action.payload.error
          });
        case _content.actionTypes.SEND_NOTIFICATION:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            error: action.payload.data
          });
        default:
          return _objectSpread({}, state);
      }
    case _content.actionTypes.RESET:
      return INIT_STATE;
    case _content.actionTypes.RESET_EDITOR_LOCK:
      return _objectSpread(_objectSpread({}, state), {}, {
        editorLock: null
      });
    case _content.actionTypes.RESET_EDITOR_UNLOCK:
      return _objectSpread(_objectSpread({}, state), {}, {
        editorUnlock: null
      });
    default:
      return _objectSpread({}, state);
  }
};
var _default = content;
exports.default = _default;